import * as selectors from './instances.selectors';
import reducer from './instances.reducers';

export default reducer;
export { selectors, reducer };
export { InstanceAction } from './instances.actions';
export { InstanceEffects } from './instances.effects';
export { InstanceState, Instance, InstanceRelationships } from './instances.models';
export { InstanceService } from './instances.service';
